import { createAsyncThunk } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import axios from 'axios';
import { TipoProdutoUtils } from '../../shared-components/select-tipo-produto/tipoProdutoUtils';
import { tarifarioAPI } from './tarifarioAPI';
import { setErrorFeedback, setSuccessFeedback } from '../feedback/feedbackSlice';


const viaTransporte = {
  MARITIMO: 'MARITIMO',
  AEREO: 'AEREO',
}

const fetchFollowUpAgenciamentoWithPaginationAsync = createAsyncThunk(
  'followUp/fetchFollowUpAgenciamentoWithPagination',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await tarifarioAPI?.fetchByFilterPagination([
        {
          name: 'servicoProduto',
          value: TipoProdutoUtils.AGENCIAMENTO_IMPORTACAO,
        },
        ...params,
      ]);

      return { data };
    } catch (err) {
      if (axios.isCancel(err)) return rejectWithValue(err);
      console.log(err);
      dispatch(setErrorFeedback({ message: `Erro ao buscar follow-up: ${err}` }));

      return rejectWithValue(err);
    }
  }
);


const inactivateByIdAsync = createAsyncThunk('tarifario/inactivateById', async (payload, thunkAPI) => {
  try {
    const { status, data } = await tarifarioAPI.inactivateById(payload);

    if (status === 200) {
      thunkAPI.dispatch(setSuccessFeedback({ message: 'tarifario inativado com sucesso' }));
    }

    return { response: { status, data } };
  } catch (err) {
    if (err?.response?.data?.message) {
      thunkAPI.dispatch(setErrorFeedback({ message: `Erro ao inativar tarifario: ${err?.response?.data?.message}` }));
    } else {
      thunkAPI.dispatch(setErrorFeedback({ message: `Erro ao inativar tarifario` }));
    }

    return { response: { status: 500, data: err?.message } };
  }
});

const fetchAgenciamentoWithPaginationAsync = createAsyncThunk(
  'tarifario/fetchAgenciamentoWithPagination',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await tarifarioAPI.fetchByFilterPagination([
        ...params,
      ]);

      return { data };
    } catch (err) {
      if (axios.isCancel(err)) return rejectWithValue(err);

      console.log(err);
      dispatch(setErrorFeedback({ message: `Erro ao buscar follow-up: ${err}` }));

      return rejectWithValue(err);
    }
  }
);


const fetchByIdAsync = createAsyncThunk('tarifario/fetchById', async (data) => {
  const response = await tarifarioAPI.fetchById(data);
  return {
    response: {
      status: response.status,
      data: response.data,
    },
  };
});

const tarifarioThunks = {
  fetchFollowUpAgenciamentoWithPaginationAsync,
  fetchAgenciamentoWithPaginationAsync,
  fetchByIdAsync,
  inactivateByIdAsync,
};

export {
  tarifarioThunks,
  fetchFollowUpAgenciamentoWithPaginationAsync,
  fetchAgenciamentoWithPaginationAsync,
  fetchByIdAsync,
  inactivateByIdAsync,
};
